import { Component } from "react"
import { ButtonBase } from "@mui/material"
import PropTypes from "prop-types"

class Result extends Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
  }

  onClick = () => {
    const { item, onClick } = this.props
    onClick(item)
  }

  render() {
    const { item: { name, disabled, info } } = this.props

    // ButtonBase, not MenuItem: this list isn't inside a Menu/MenuList, and MUI's
    // MenuItem now requires that context unconditionally.
    return <ButtonBase classes={{ root: "result-item" }} component="div" disabled={disabled} onClick={this.onClick} title={name}>
      <div className="result-label">{name}</div>
      {info && <div className="info-label">({info})</div>}
    </ButtonBase>
  }
}

export default Result
